import React from 'react'
import { camelCase } from 'lodash'
import classnames from 'classnames'

import * as icons from './icons'

export interface CateogryIconProps extends React.SVGProps<SVGSVGElement> {
  categoryName: string
}

const CateogryIcon: React.SFC<CateogryIconProps> = ({ categoryName, className, ...rest }) => {
  const classes = classnames(className)
  const exportName = camelCase(categoryName)
  let Icon: React.StatelessComponent<React.SVGAttributes<SVGElement>>

  // @ts-ignore Typescript does not understand the glob import
  Icon = icons[exportName] || null

  return Icon && <Icon className={classes} {...rest} />
}

export default CateogryIcon
